export enum DocumentType {
  CPF = 'cpf',
  CNPJ = 'cnpj',
}
